import HallOverviewFilterForm from "./hall-overview-filter-form";

import "./hall-forms.scss";


const HallForms = {
    OverviewFilter : HallOverviewFilterForm
}

export default HallForms;